import { ContactMessage } from "../models/ContactMessage.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * ContactViewModel is a shared VM for the Contact page. Sites differ only in
 * styling (the View) and in the injected submit strategy.
 */
export class ContactViewModel extends ViewModel {
    onSubmit;
    constructor(onSubmit) {
        super({ name: "", email: "", body: "", errors: [], submitting: false, submitted: false });
        this.onSubmit = onSubmit;
    }
    setName(name) {
        this.setState({ name });
    }
    setEmail(email) {
        this.setState({ email });
    }
    setBody(body) {
        this.setState({ body });
    }
    async submit() {
        const message = new ContactMessage(this.state.name, this.state.email, this.state.body);
        const errors = message.validate();
        if (errors.length > 0) {
            this.setState({ errors });
            return false;
        }
        const ok = await this.run(async () => {
            await this.onSubmit(message);
            this.setState({ submitted: true });
            return true;
        }, "Could not send your message. Please try again.", { flag: "submitting", listErrors: true });
        return ok === true;
    }
}
//# sourceMappingURL=ContactViewModel.js.map